import { api } from "../../services";
import { uiActions } from "../ui";

import {
  SET_STRATEGIES,
  SET_COMPARE_STRATEGIES,
  ADD_TO_COMPARE,
  REMOVE_FROM_COMPARE,
  CLEAR_STRATEGIES,
  RECIEVE_TREATMENTGROUPS,
  SET_TREATMENTGROUP_ID,
} from "./types";

export const requestStrategies = (cropId, seasonId, weeds, treatmentGroupId) => (dispatch, useState) => {
  dispatch(uiActions.setLoading(true));
  dispatch(setTreatmentGroupValue(treatmentGroupId));
  return api
    .getStrategies(cropId, seasonId, weeds, treatmentGroupId)
    .then(strategies => {
      dispatch(uiActions.setLoading(false));
      dispatch(recieveStrategies(strategies));
    })
    .catch(e => {
      dispatch(uiActions.setLoading(false));
      dispatch(uiActions.showMessage("Kunde inte hämta strategier"));
    });
};

export const requestTreatmentGroups =
  (cropId, seasonId, weeds, treatmentGroupId) => (dispatch, useState) => {
    dispatch(uiActions.setLoading(true));
    return api
      .getTreatmentGroupNames(cropId, seasonId, weeds, treatmentGroupId)
      .then((treatmentGroups) => {
        dispatch(uiActions.setLoading(false));
        dispatch(recieveTreatmentGroups(treatmentGroups));
      })
      .catch((e) => {
        dispatch(uiActions.setLoading(false));
        dispatch(uiActions.showMessage("Kunde inte hämta behandlingar"));
      });
  };

const recieveStrategies = strategies => {
  return {
    type: SET_STRATEGIES,
    payload: strategies
  };
};

export const addToCompare = id => (dispatch, useState) => {
  let state = useState();
  const maxCompare = window.matchMedia("(max-width: 768px)").matches ? 2 : 4;
  if (state.strategies.compareStrategyIds.length >= maxCompare) {
    dispatch(uiActions.showMessage(`Du kan bara jämföra ${maxCompare} åt gången${maxCompare === 2 ? '  på små skärmar': ''}`));
  } else {
    dispatch({
      type: ADD_TO_COMPARE,
      payload: id
    });
  }
};

const recieveTreatmentGroups = (treatmentGroups) => {
  return {
    type: RECIEVE_TREATMENTGROUPS,
    payload: treatmentGroups,
  };
};

export const removeFromCompare = id => {
  return {
    type: REMOVE_FROM_COMPARE,
    payload: id
  };
};

export const compareStrategies = (cropId, seasonId, strategies,weeds) => dispatch => {
  dispatch(uiActions.setLoading(true));
  return api
    .getCompareStrategies(cropId, seasonId, strategies,weeds)
    .then(data => {
      dispatch(uiActions.setLoading(false));
      dispatch(recieveCompareStrategies(data));
    })
    .catch(e => {
      dispatch(uiActions.setLoading(false));
    });
};

const recieveCompareStrategies = strategies => {
  return {
    type: SET_COMPARE_STRATEGIES,
    payload: strategies
  };
};

const setTreatmentGroupValue = (id) => {
  return {
    type: SET_TREATMENTGROUP_ID,
    payload: id,
  };
};

export const clearStrategies = () => {
  return {
    type: CLEAR_STRATEGIES
  }
}

export const changeSelectedTreatmentGroup =
  (cropId, seasonId, weeds, groupId) => (dispatch, useState) => {
    dispatch(uiActions.setLoading(true));
    let state = useState();
    state.strategies.selectedTreatmentGroupValue = groupId;
    return api
      .getStrategies(cropId, seasonId, weeds, groupId)
      .then((strategies) => {
        dispatch(recieveStrategies(strategies));
        dispatch(uiActions.setLoading(false));
      })
      .catch((e) => {
        dispatch(uiActions.setLoading(false));
        dispatch(uiActions.showMessage("Kunde inte hämta ogräsgrupper"));
      });
  };